// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".anticon.session-info-icon {\n  color: #9ba0aa;\n  margin-right: 12px;\n}\n", "",{"version":3,"sources":["webpack://src/modules/documents/components/SessionInfoLabel/SessionInfoLabel.less"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,kBAAkB;AACpB","sourcesContent":[".anticon.session-info-icon {\n  color: #9ba0aa;\n  margin-right: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
